import LinkLoader from './LinkLoader';

export default LinkLoader;
